"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TierSummaryWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var commonFunctions_1 = require("../../../commonFunctions");
var core_1 = require("@athena-portal/core");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var services_1 = require("@falcon/services");
var AggRefAndQuoteNumberOutputWidget_1 = require("./AggRefAndQuoteNumberOutputWidget");
var DrivingLicencePriceUpdateBanner_1 = require("./DrivingLicencePriceUpdateBanner");
var TierSummaryWidget = /** @class */ (function (_super) {
    __extends(TierSummaryWidget, _super);
    function TierSummaryWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.previousPremium = 0;
        if (_this.props.interaction.product === services_1.PRODUCT_WOLF_MOTOR) {
            _this.previousPremium = _this.props.interaction.factors.premiumType === services_1.PREMIUM_TYPE_ANNUAL ?
                _this.props.interaction.factors.annualPremium : _this.props.interaction.paymentDetails.instalmentPlan.monthlyPayment;
        }
        return _this;
    }
    TierSummaryWidget.prototype.render = function () {
        var _a;
        var interaction = this.props.interaction;
        var monthlyPremium = (_a = interaction.paymentDetails.instalmentPlan) === null || _a === void 0 ? void 0 : _a.monthlyPayment;
        var annualPremium = interaction.factors.annualPremium;
        var premiumType = interaction.factors.premiumType;
        var formattedFirstName = this.addSoftHyphens(interaction.policyHolder.firstName);
        var premiumToDisplay = (interaction.factors.premiumType === services_1.PREMIUM_TYPE_ANNUAL)
            ? (annualPremium === 0) ? this.previousPremium : annualPremium
            : (monthlyPremium === 0) ? this.previousPremium : monthlyPremium;
        this.previousPremium = premiumToDisplay;
        var isNotPendingMta = interaction.status !== services_1.INTERACTION_STATUS_PENDING_MTA;
        var eligibleTiersMotor = (0, commonFunctions_1.getEligibleTiers)(this.props.interaction);
        var eligibleTiersHome = (0, commonFunctions_1.getHomeEligibleTiers)(this.props.interaction);
        var isMotorProduct = services_1.productHelper.isWolfMotor(this.props.interaction);
        var isHomeProduct = services_1.productHelper.isHome(this.props.interaction);
        var spanColor = (services_1.resourcesHelper.THEME === "Britannia") ? "#F62459" : "#51b6dd";
        var showDlnPriceUpdateBanner = interaction.uistate.showDlnPriceUpdateBanner;
        return ((0, jsx_runtime_1.jsxs)("div", { className: "tier-summary-container ".concat(this.getSetting("cssClass", "")), children: [isNotPendingMta && (0, jsx_runtime_1.jsx)(AggRefAndQuoteNumberOutputWidget_1.AggRefAndQuoteNumberOutputWidget, { source: interaction.source, quoteRef: interaction._id }), showDlnPriceUpdateBanner && (0, jsx_runtime_1.jsx)(DrivingLicencePriceUpdateBanner_1.DrivingLicencePriceUpdateBanner, { interaction: interaction }), (0, jsx_runtime_1.jsxs)("div", { className: "tier-summary-widget w-100", children: [(0, jsx_runtime_1.jsxs)("h1", { className: "pt-0", children: ["Hi ", formattedFirstName, ",", (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsxs)("span", { style: { color: spanColor }, children: ["here\u2019s your ", this.getQuoteType(isMotorProduct), " quote"] })] }), (0, jsx_runtime_1.jsxs)("div", { className: "premium-and-tax-output d-flex justify-content-between align-items-end heading-row", children: [(0, jsx_runtime_1.jsxs)("span", { children: ["All figures include ", premiumType === services_1.PREMIUM_TYPE_ANNUAL || !isMotorProduct ? 'Insurance Premium Tax' : 'Interest and Insurance Premium Tax'] }), (0, jsx_runtime_1.jsxs)("h2", { className: "mt-3 mb-0 tier-premium", children: [isMotorProduct && !interaction.uistate.selectedCoverTier && eligibleTiersMotor.length > 1 &&
                                            (0, jsx_runtime_1.jsx)("span", { className: "premium-type mb-0 mr-2", style: { verticalAlign: "baseline" }, children: "From " }), isHomeProduct && !interaction.coverTier && eligibleTiersHome.length > 1 &&
                                            (0, jsx_runtime_1.jsx)("span", { className: "premium-type mb-0 mr-2", style: { verticalAlign: "baseline" }, children: "From " }), (0, commonFunctions_1.getAmountToDisplay)(premiumToDisplay), (0, jsx_runtime_1.jsx)("span", { className: "premium-type mb-0 ml-1", style: { verticalAlign: "baseline" }, children: interaction.factors.premiumType === services_1.PREMIUM_TYPE_ANNUAL
                                                ? "/ year"
                                                : "/ month" })] })] })] })] }));
    };
    TierSummaryWidget.prototype.addSoftHyphens = function (value) {
        if (!value) {
            return value;
        }
        return value.split("").join("\u00AD");
    };
    TierSummaryWidget.prototype.getQuoteType = function (isMotorProduct) {
        if (isMotorProduct) {
            return "car";
        }
        var coverLevel = this.props.interaction.coverLevel;
        if ((0, commonFunctions_1.isCoverLevelContentsOnly)(coverLevel)) {
            return "contents insurance";
        }
        if ((0, commonFunctions_1.isCoverLevelBuildingsOnly)(coverLevel)) {
            return "buildings insurance";
        }
        return "home";
    };
    __decorate([
        (0, core_1.lazyInject)(plugin_journey_1.Types.LookupService),
        __metadata("design:type", Object)
    ], TierSummaryWidget.prototype, "previousPremium", void 0);
    return TierSummaryWidget;
}(plugin_journey_1.WidgetBase));
exports.TierSummaryWidget = TierSummaryWidget;
//# sourceMappingURL=TierSummaryWidget.js.map